/*
  Project: SOS Media Corp
  Author: Mat @ SOS Media Corp
 */

import $ from 'jquery';
import menu from './modules/Menu';
import {slickInit} from './modules/slick';
import accordion from './modules/accordion';
import watermark from './modules/watermark';
// import barba from '@barba/core'
import AjaxPosts from './modules/Ajax';
import {new_map} from './modules/GoogleMap'
import ImageModal from './modules/imageModal'
// barba.init({
//   transitions: [{
//     name: 'opacity-transition',
//     leave(data) {
//       $('.page-loader').addClass('is-active');
//     },
//     enter(data) {
//       slickInit();
//       setTimeout(() => {
//         $('.page-loader').removeClass('is-active')
//       }, 2000)
//     }
//   }]
// });

$(document).ready(() => {
  menu();
  slickInit();
  accordion();
  watermark();
  const imageModal = new ImageModal();

  let map = null;
  $('.acf-map').each(function () {
    // create map
    map = new_map($(this));
  });

  $('.js-ajax-load').on('click', (e) => {
    const ajax = new AjaxPosts(e.currentTarget);
    ajax.ajax();
  })

  $('.js-ajax-filter').on('click', (e) => {

    const archiveButton = $(e.currentTarget).closest('.block-archive').find('.js-ajax-load');
    const ajax = new AjaxPosts(archiveButton);
    ajax.handleSorting(e.currentTarget);
  })

  $('.js-search').on('click', () => {
    $('.search-modal').toggleClass('is-active')
    $('.site-header').removeClass('menu-is-open')
  })

  $('.search-modal__exit').on('click', () => $('.search-modal').removeClass('is-active'))


  if(window.location.hash)
  {
    const objScrollTo = $(`.${window.location.hash.replace('#', '')}`)
    if (objScrollTo.length) {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: objScrollTo.offset().top - 50
        },
        750
      );
    }
  }
});



// WEBPACK FOOTER //
// ./wp/wp-content/themes/ukrainian-museum-theme/src/scripts/app.js